import { render, staticRenderFns } from "./xmlSiparisDetayButon.vue?vue&type=template&id=46bc0fd6"
import script from "./xmlSiparisDetayButon.vue?vue&type=script&lang=js"
export * from "./xmlSiparisDetayButon.vue?vue&type=script&lang=js"
import style0 from "./xmlSiparisDetayButon.vue?vue&type=style&index=0&id=46bc0fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports